module.exports = __webpack_public_path__ + "static/media/extension2.4f31e465.png";